/* PLACE-CONTEXT-UI-ADAPTER-01
 * Owner: Place Context panel presentation.
 * Map selection remains owned by gcitymap-platform.js.
 * No game, storage, API, URL, identity or payment operations.
 * Map selection is not proof of a verified Place or relationship.
 */
(function () {
  'use strict';

  const VERSION = '2026-10-11-place-context-ui-adapter-01';
  const existing = window.LittleGCityMissionEnginePolish;

  if (existing && existing.version === VERSION) return;

  function syncPanels() {
    if (!document.querySelector('[data-gcp-place-context]')) return;

    const isZh = (
      document.documentElement.lang || ''
    ).toLowerCase().startsWith('zh');

    document.querySelectorAll('[data-gcp-place-panel]').forEach(
      function (panel) {
        const workspace = panel.closest(
          '[data-gproperty-map-workspace]'
        );
        const status = panel.querySelector('[data-gcp-place-status]');
        const content = panel.querySelector('[data-gcp-place-content]');

        if (!workspace || !status || !content) return;

        // Read current map state, not an assumed event payload.
        // This reference may be temporary; it is not canonical identity.
        const reference = (
          workspace.getAttribute('data-selected-estate') || ''
        ).trim();

        const selected = reference !== '';
        const state = selected ? 'unverified' : 'awaiting-selection';
        const message = selected
          ? (isZh
              ? '工程位置與招標關係待確認。'
              : 'Project locations and tender relationships require confirmation.')
          : (isZh
              ? '在地圖上選擇地點，開始探索周邊'
              : 'Select a location to explore surroundings');

        panel.setAttribute('data-gcp-context-state', state);
        status.removeAttribute('data-tone');

        if (status.textContent.trim() !== message) {
          status.textContent = message;
        }

        // No verified relationship producer is connected in this round.
        // Invalidate old content; never reveal an empty or stale panel.
        content.hidden = true;
        content.replaceChildren();
      }
    );
  }

  // One listener set for the document lifetime.
  // Each call finds current DOM nodes; no unloaded section is retained.
  window.addEventListener('gproperty:estate:selected', syncPanels);
  window.addEventListener('gproperty:estate:cleared', syncPanels);
  window.addEventListener('pageshow', syncPanels);
  document.addEventListener('shopify:section:load', syncPanels);

  window.LittleGCityMissionEnginePolish = {
    version: VERSION,
    role: 'page-ui-adapter'
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPanels, {
      once: true
    });
  } else {
    syncPanels();
  }
})();
